export default __webpack_public_path__ + "static/media/news19.75fdf866.jpg";